module.exports = __webpack_public_path__ + "img/84e9818.png";